import React from "react";
import { Box, Typography, Chip, alpha } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const getSemaforoColor = (cantidad, semaforoInfo, clienteId, tipoServicio, theme) => {
  if (semaforoInfo && semaforoInfo[clienteId] && semaforoInfo[clienteId].tieneConfiguracion) {
    const config = semaforoInfo[clienteId];
    if (config.tipoAplicacion === tipoServicio || config.tipoAplicacion === "Ambos") {
      return tipoServicio === "Compromisos" ? config.colorCompromisos : config.colorObligaciones;
    }
  }
  if (cantidad === 0) return theme.palette.success.main;
  if (cantidad <= 2) return theme.palette.warning.main;
  return theme.palette.error.main;
};

export const SemaforoBadge = ({ cantidad, documento, tipo }) => {
  const theme = useTheme();
  const clienteId =
    documento?.clientes && documento.clientes.length > 0 ? documento.clientes[0].id : null;

  const config = documento?.semaforoInfo?.[clienteId];
  const aplica =
    config?.tieneConfiguracion &&
    (config.tipoAplicacion === tipo || config.tipoAplicacion === "Ambos");

  if (!aplica) {
    return (
      <Typography variant="body2" sx={{ fontVariantNumeric: "tabular-nums" }}>
        {cantidad}
      </Typography>
    );
  }

  const color = getSemaforoColor(cantidad, documento.semaforoInfo, clienteId, tipo, theme);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.75,
        minWidth: 34,
        px: 1,
        py: 0.25,
        borderRadius: 999,
        backgroundColor: alpha(color, 0.14),
      }}
    >
      <Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: color, flexShrink: 0 }} />
      <Typography
        variant="body2"
        sx={{ fontWeight: 700, color: "text.primary", fontVariantNumeric: "tabular-nums" }}
      >
        {cantidad}
      </Typography>
    </Box>
  );
};

export const EstadoChip = ({ estado }) => {
  const theme = useTheme();
  if (!estado) return null;

  const normalized = estado.toLowerCase();
  let color = theme.palette.text.secondary;
  if (normalized.includes("vigente") && !normalized.includes("próxima")) color = theme.palette.success.main;
  else if (normalized.includes("próxima")) color = theme.palette.warning.main;
  else if (normalized.includes("trámite") || normalized.includes("tramite")) color = theme.palette.info.main;
  else if (normalized.includes("derogad") || normalized.includes("no vigente")) color = theme.palette.error.main;

  return (
    <Chip
      label={estado}
      size="small"
      variant="outlined"
      sx={{
        color,
        borderColor: alpha(color, 0.4),
        backgroundColor: alpha(color, 0.08),
        fontWeight: 600,
        fontSize: "0.72rem",
        height: 24,
      }}
    />
  );
};

export default SemaforoBadge;